interface TrackerTariffInfo {
  data?: {
    tariff?: {
      depth?: number;
      weekly_updates?: number;
      num_of_keywords?: number;
    };
  };
}

export const isTrackerTariffInactive = (
  trackerInfo: TrackerTariffInfo | undefined
): boolean => {
  const tariff = trackerInfo?.data?.tariff;
  if (!tariff) return false;

  return (
    tariff.depth === 0 &&
    tariff.weekly_updates === 0 &&
    tariff.num_of_keywords === 0
  );
};

export const TRACKER_INACTIVE_MESSAGE =
  'افزونه ردیاب کلمات برای دامنهٔ شما فعال نیست. برای دسترسی به این بخش، لطفاً افزونه ردیاب را خریداری کنید.';

export const isTrackerKeywordsTariffZero = (
  trackerInfo: TrackerTariffInfo | undefined
): boolean => trackerInfo?.data?.tariff?.num_of_keywords === 0;

export const TRACKER_KEYWORDS_INACTIVE_TOOLTIP =
  'با توجه به طرح فعلی این بخش برای شما فعال نیست.';
